module.exports = __webpack_public_path__ + "img/TinyTAN_Sweet_Dreams_03.05250841.png";